import { Component, inject } from '@angular/core';

import { ToastService } from './toast.service';

@Component({
  standalone: true,
  imports: [],
  selector: 'shared-toast-viewport',
  template: `
    <div
      class="pointer-events-none fixed right-4 top-4 z-[1000] flex w-[calc(100%-2rem)] max-w-sm flex-col gap-3 sm:right-6 sm:top-6"
      aria-live="polite"
      aria-atomic="true"
    >
      @for (toast of toastService.toasts(); track toast.id) {
      <div
        class="pointer-events-auto overflow-hidden rounded-md border border-green-200 bg-white shadow-lg"
        role="status"
      >
        <div class="flex items-start gap-3 p-4">
          <div class="mt-0.5 flex-shrink-0">
            <svg
              class="h-5 w-5 text-green-500"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
          </div>

          <p class="min-w-0 flex-1 text-sm font-medium text-gray-900">
            {{ toast.message }}
          </p>

          <button
            type="button"
            class="-m-1.5 inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-green-600"
            aria-label="Dismiss notification"
            (click)="toastService.dismiss(toast.id)"
          >
            <svg
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
              />
            </svg>
          </button>
        </div>
      </div>
      }
    </div>
  `,
})
export class ToastViewportComponent {
  protected readonly toastService = inject(ToastService);
}
